<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
<path d="M12 20C13.4728 20 14.6667 18.8061 14.6667 17.3334C14.6667 15.8606 13.4728 14.6667 12 14.6667C10.5273 14.6667 9.33334 15.8606 9.33334 17.3334C9.33334 18.8061 10.5273 20 12 20Z"/>
</svg>
